/** 公司维度能力（与 GET /api/companies 每条上的 permissions 一致） */
export const COMPANY_PERM = {
  SCRIPT_ONLINE: 'company:script:online',
  VOICE_GENERATION: 'company:voice:generation',
  AI_AUDIOBOOK_GENERATION: 'company:ai:audiobook:generation',
  VIDEO_DRAMA_RECORDING: 'company:video:recording:drama'
}

/**
 * @param {unknown} res getCompanyList 等接口的响应体
 * @returns {Array<Record<string, unknown>>}
 */
export function parseCompanyListFromResponse (res) {
  const list = res?.data?.list ?? res?.list ?? res?.data ?? (Array.isArray(res) ? res : [])
  return Array.isArray(list) ? list : []
}

/**
 * @param {Array<Record<string, unknown>>} companies
 * @param {string} permission
 */
export function filterCompaniesByPermission (companies, permission) {
  if (!Array.isArray(companies) || !permission) return []
  return companies.filter(
    (c) => Array.isArray(c.permissions) && c.permissions.includes(permission)
  )
}
